import { requestOptions } from '../helpers/request-options'
import { handleResponse } from '../helpers/handle-response'

export const activitiyService = {
  getData,
  addData,
  deleteData,
  updateData
}

function getData () {
  const url = `${process.env.VUE_APP_ACTIVE_DOMAIN_URL}/activities/api/activities/`
  return fetch(url, requestOptions.get())
    .then(handleResponse)
    .then(activities => {
      return activities
    })
}

function addData (payload) {
  const url = `${process.env.VUE_APP_ACTIVE_DOMAIN_URL}/activities/api/activities/`
  return fetch(url, requestOptions.post(payload))
    .then(handleResponse)
    .then(activities => {
      return activities
    })
}

function deleteData (id) {
  const url = `${process.env.VUE_APP_ACTIVE_DOMAIN_URL}/activities/api/activities/${id}`
  return fetch(url, requestOptions.delete())
    .then(handleResponse)
    .then(activities => {
      return activities
    })
}

function updateData (payload, id) {
  const url = `${process.env.VUE_APP_ACTIVE_DOMAIN_URL}/activities/api/activities/${id}/`
  return fetch(url, requestOptions.put(payload))
    .then(handleResponse)
    .then(activities => {
      return activities
    })
}



// WEBPACK FOOTER //
// ./src/services/activities.service.js